import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatOptionModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatExpansionModule} from '@angular/material/expansion';
import {AdvancedSearchboxComponent} from './components/advanced-searchbox/advanced-searchbox.component';
import {ConfirmationDialogComponent} from './components/confirmation-dialog/confirmation-dialog.component';
import {I18nDictionaryComponent} from './components/i18n-dictionary/i18n-dictionary.component';
import {SpinnerPageComponent} from './components/spinner-page/spinner-page.component';
import {IosAutoFillFixDirective} from './directives/ios-auto-fill-fix.directive';
import {RepeatDirective} from './directives/repeat.directive';
import {TemplatePortalDirective} from './directives/template-portal.directive';
import {TitleService} from './services/title.service';
import {BackgroundImageRatioDirective} from './directives/background-image-ratio.directive';
import { AutofocusDirective } from './directives/autofocus.directive';

export const MaterialModules = [
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatSidenavModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatSelectModule,
    MatTooltipModule,
    MatOptionModule,
    MatExpansionModule
];

const ENTRY_COMPONENTS = [
    ConfirmationDialogComponent
];

export const COMPONENTS = [
    ENTRY_COMPONENTS,
    TemplatePortalDirective,
    IosAutoFillFixDirective,
    RepeatDirective,
    AdvancedSearchboxComponent,
    I18nDictionaryComponent,
    SpinnerPageComponent,
    BackgroundImageRatioDirective,
    AutofocusDirective,
];

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        MaterialModules,
    ],
    declarations: [COMPONENTS],
    providers: [TitleService],
    exports: [
        COMPONENTS,
        CommonModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        MaterialModules
    ]
})
export class SharedModule {
}
